import React, { useState } from "react";
import { toast } from "sonner";
import { Upload, FileText } from "lucide-react";
import api, { BACKEND_URL } from "../../lib/api";

export default function ResumeUploader() {
  const [loading, setLoading] = useState(false);

  const onUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.name.toLowerCase().endsWith(".pdf")) {
      toast.error("PDF only");
      return;
    }
    const fd = new FormData();
    fd.append("file", file);
    setLoading(true);
    try {
      await api.post("/resume/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success("Resume uploaded.");
    } catch (err) {
      toast.error("Upload failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-resume-uploader">
      <h2 className="font-display font-bold text-2xl mb-6">Resume</h2>
      <div className="card-tech p-8 text-center">
        <FileText className="w-10 h-10 text-volt mx-auto" />
        <p className="mt-3 text-fog-300">Upload a PDF. It replaces the current one at /api/resume.</p>
        <div className="mt-6">
          <label className="btn-volt cursor-pointer inline-flex" data-testid="admin-resume-input-label">
            <Upload className="w-4 h-4" /> {loading ? "Uploading…" : "Upload PDF"}
            <input type="file" accept="application/pdf" onChange={onUpload} className="hidden" data-testid="admin-resume-input" />
          </label>
        </div>
        <div className="mt-6">
          <a href={`${BACKEND_URL}/api/resume`} target="_blank" rel="noreferrer" className="text-volt text-sm underline" data-testid="admin-resume-download">
            View / download current resume
          </a>
        </div>
      </div>
    </div>
  );
}
